import React from "react";

const PeopleIcon = ({ fill }) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8185 10.25C11.5745 9.335 12.719 8.75 14 8.75C15.281 8.75 16.4255 9.335 17.1815 10.25C17.6792 10.8535 17.9951 11.586 18.0923 12.3622C18.1895 13.1384 18.0639 13.9262 17.7304 14.6338C17.3968 15.3413 16.8689 15.9394 16.2082 16.3583C15.5476 16.7772 14.7815 16.9997 13.9993 16.9997C13.217 16.9997 12.4509 16.7772 11.7903 16.3583C11.1296 15.9394 10.6017 15.3413 10.2681 14.6338C9.93455 13.9262 9.80903 13.1384 9.90621 12.3622C10.0034 11.586 10.3193 10.8535 10.817 10.25H10.8185ZM19.625 12.875C19.625 11.927 19.391 11.033 18.977 10.25H25.25C25.8467 10.25 26.419 10.4871 26.841 10.909C27.2629 11.331 27.5 11.9033 27.5 12.5V13.25C27.5 15.6305 25.691 18.068 22.5275 18.926C22.2024 18.342 21.7271 17.8555 21.1509 17.5169C20.5746 17.1783 19.9184 16.9998 19.25 17H17.825C18.3935 16.4739 18.847 15.8359 19.1568 15.1259C19.4666 14.416 19.626 13.6496 19.625 12.875ZM19.25 18.5C19.5457 18.4992 19.8386 18.5569 20.112 18.6697C20.3853 18.7825 20.6337 18.9482 20.8428 19.1572C21.0518 19.3663 21.2175 19.6147 21.3303 19.888C21.4431 20.1614 21.5008 20.4543 21.5 20.75V21.5C21.5 24.4565 18.71 27.5 14 27.5C9.29 27.5 6.5 24.4565 6.5 21.5V20.75C6.49921 20.4543 6.55687 20.1614 6.66966 19.888C6.78245 19.6147 6.94815 19.3663 7.15724 19.1572C7.36633 18.9482 7.61469 18.7825 7.88803 18.6697C8.16137 18.5569 8.4543 18.4992 8.75 18.5H19.25ZM0.5 13.25C0.5 15.6305 2.309 18.068 5.4725 18.926C5.7976 18.342 6.27287 17.8555 6.84911 17.5169C7.42535 17.1783 8.08163 16.9998 8.75 17H10.175C9.60645 16.4739 9.153 15.8359 8.84321 15.1259C8.53342 14.416 8.374 13.6496 8.375 12.875C8.375 11.927 8.609 11.033 9.0245 10.25H2.75C2.15326 10.25 1.58097 10.4871 1.15901 10.909C0.737053 11.331 0.5 11.9033 0.5 12.5V13.25ZM12.125 4.625C12.125 3.53098 11.6904 2.48177 10.9168 1.70818C10.1432 0.934597 9.09402 0.5 8 0.5C6.90598 0.5 5.85677 0.934597 5.08318 1.70818C4.3096 2.48177 3.875 3.53098 3.875 4.625C3.875 5.71902 4.3096 6.76823 5.08318 7.54182C5.85677 8.3154 6.90598 8.75 8 8.75C9.09402 8.75 10.1432 8.3154 10.9168 7.54182C11.6904 6.76823 12.125 5.71902 12.125 4.625ZM24.125 4.625C24.125 3.53098 23.6904 2.48177 22.9168 1.70818C22.1432 0.934597 21.094 0.5 20 0.5C18.906 0.5 17.8568 0.934597 17.0832 1.70818C16.3096 2.48177 15.875 3.53098 15.875 4.625C15.875 5.71902 16.3096 6.76823 17.0832 7.54182C17.8568 8.3154 18.906 8.75 20 8.75C21.094 8.75 22.1432 8.3154 22.9168 7.54182C23.6904 6.76823 24.125 5.71902 24.125 4.625Z"
        fill={fill}
      />
    </svg>
  );
};

export default PeopleIcon;

export const PersonIcon = ({ fill }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
        fill={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
        strokeWidth="2"
        fill={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
